import { observable, makeObservable, action } from "mobx";
import axios from "axios";
import { api } from "../../constants/apis";
import { post } from "../../utils/axios-requests";

export default class CreateAccountUiStore {
  @observable error: string = "";

  constructor() {
    makeObservable(this);
  }

  private capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  private sendConfirmationEmail = async (values: any) => {
    try {
      await axios.post(api.users.confirmEmail, {
        email: values.email,
      });
    } catch (error: any) {
      this.setError(error.response.data);
    }
  };

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public submitData = async (values: any) => {
    try {
      const res = await post(
        api.users.all,
        {
          firstName: this.capitalizeFirstLetter(values.firstName),
          lastName: this.capitalizeFirstLetter(values.lastName),
          userLang: 'en',//window.localStorage.getItem("rcml-lang"),
        },
        {},
        {
          username: values.email,
          password: values.password,
        }
      );

      if (res.status !== 200) {
        return false;
      }

      this.sendConfirmationEmail(values);

      return true;
    } catch (error: any) {

      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };
}
